import { Timeouts } from '@gap/utils/date-utils'
import { STATUS_PATH } from '@gap/utils/kill-switch'

/** What the holding-page watcher fetches with, how it reloads the tab and how often it checks. */
export interface WatchHoldingPageOptions {
   fetchStatus?: typeof fetch
   reload?: () => void
   everyMs?: number
}

/**
 * Checks the site's status every interval and reloads the tab once the holding page shows.
 *
 * @param options The status fetch, the tab reload and the interval in milliseconds, each defaulting to the browser's own.
 */
export function watchHoldingPage({ fetchStatus = fetch, reload = () => location.reload(), everyMs = Timeouts.minute }: WatchHoldingPageOptions = {}): void {
   const interval = setInterval(() => {
      checkStatus()
   }, everyMs)

   /** Fetches the status and reloads the tab when it says the holding page shows. */
   async function checkStatus(): Promise<void> {
      try {
         const reply = await fetchStatus(STATUS_PATH, { cache: 'no-store' })
         const status = (await reply.json()) as { show?: unknown } | null
         if (status?.show !== true) return
         clearInterval(interval)
         reload()
      } catch {
         // A failed fetch or a body that is not JSON leaves the tab alone.
      }
   }
}
